import { render } from "./PagamentoMP.vue?vue&type=template&id=ebeab98c&scoped=true"
import script from "./PagamentoMP.vue?vue&type=script&lang=js"
export * from "./PagamentoMP.vue?vue&type=script&lang=js"

import "./PagamentoMP.vue?vue&type=style&index=0&id=ebeab98c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebeab98c"]])

export default __exports__